import React, { useEffect } from "react";
import { Accordion, AccordionDetails, AccordionSummary,CircularProgress, Box, Button, Checkbox, Divider, FormControl, FormControlLabel, Grid, Input, InputAdornment, Paper, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { useState, useRef, useMemo } from 'react';
import PersonIcon from '@mui/icons-material/Person';
import InputStyle from "../../../assets/InputStyle";
import flagIcon from "../../../images/flagIcon.png";
import { Select, MenuItem } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CloudUploadIcon from '../../../images/upload.svg';
import AddIcon from '@mui/icons-material/Add';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import JoditEditor from "jodit-react";
import { enqueueSnackbar } from "notistack";
import { useDispatch, useSelector } from "react-redux";
import { createProfile } from "../../../actions/userAuth";
import { useNavigate } from "react-router-dom";

const Education = () => {
    const [age, setAge] = useState('');
    const [selectedYear, setSelectedYear] = useState('');
    const [selectedYear1, setSelectedYear1] = useState('');
    const [selectedMonth, setSelectedMonth] = useState('');
    const [selectedMonth1, setSelectedMonth1] = useState('');
    const [coachingField, setCoachingField] = useState('');
    const [coachingSpecification, setCoachingSpecification] = useState('');
    const [coachingCertification, setCoachingCertification] = useState('');
    const [experience, setExperience] = useState('');
    const [coachingCertificateImage, setCoachingCertificateImage] = useState('');
    const [additionalCertificationImage, setAdditionalCertificationImage] = useState('');
    const [coachingDescription, setCoachingDescription] = useState('');
    const [coachingExperience, setCoachingExperiance] = useState('');
    const [industrySpecialization, setIndustrySpecialization] = useState('');
    const [industryField, setIndustryField] = useState('');
    const [industryDescription, setIndustryDescription] = useState('');
    const [industryExperience, setIndustryExperience] = useState('');
    const [allIndustryExperience, setAllIndustryExperience] = useState([]);
    const [loading, setLoading] = useState(false);

    const [designation, setDesignation] = useState('');
    const [employeeType, setEmployeeType] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [location, setLocation] = useState('');
    const [workExperience, setworkExperience] = useState('');
    const [allWorkExperience, setAllWorkExperience] = useState([]);
    const [currentlyWorking, setCurrentlyWorking] = useState(false);
    const [value, setValue] = useState("");
    const editor = useRef(null);
    const navigate = useNavigate();

    const months = [
        { value: 1, label: 'January' },
        { value: 2, label: 'February' },
        { value: 3, label: 'March' },
        { value: 4, label: 'April' },
        { value: 5, label: 'May' },
        { value: 6, label: 'June' },
        { value: 7, label: 'July' },
        { value: 8, label: 'August' },
        { value: 9, label: 'September' },
        { value: 10, label: 'October' },
        { value: 11, label: 'November' },
        { value: 12, label: 'December' },
    ];

    const handleMonthChange = (event) => {
        setSelectedMonth(event.target.value);
    };
    const handleYearChange = (event) => {
        setSelectedYear(event.target.value);
    };

    const handleMonthChange1 = (event) => {
        setSelectedMonth1(event.target.value);
    };
    const handleYearChange1 = (event) => {
        setSelectedYear1(event.target.value);
    };

    const dispatch = useDispatch();
    // Get the current year
    const currentYear = new Date().getFullYear();

    // Generate an array of the last 30 years
    const last30Years = Array.from({ length: 30 }, (_, index) => currentYear - index);

    const {user} = useSelector((state) => ({...state}));
    useEffect(()=>{
        if(user?.coachingExperience?.length > 0){
            setCoachingExperiance(user?.coachingExperience);
        }

        if(user?.industryExperience?.length > 0){
            setAllIndustryExperience(user?.coachingExperience);
        }

        if(user?.workExperience?.length > 0){
            setAllWorkExperience(user?.workExperience);
        }
    },[user]);
    const handleChange = (event) => {
        setAge(event.target.value);
    };

    const handleAddCoachingExperiance = (event) => {
        event.stopPropagation();
        if (!coachingField || !experience || !coachingDescription) {
            enqueueSnackbar("Please fill all the necessary fields", { variant: 'warning' });
        } else {
            let val = { coachingField: coachingField, experience: experience, certificationPhotos: [URL.createObjectURL(coachingCertificateImage)], additionalCertificates: [URL.createObjectURL(additionalCertificationImage)], description: coachingDescription };
            setCoachingExperiance(oldArr => [...oldArr, val]);
        }
    }

    const handleAddIndustryExperiance = (event) => {
        event.stopPropagation();
        if (!industrySpecialization || !industryField || !industryExperience || !industryDescription) {

            enqueueSnackbar("Please fill all the necessary fields", { variant: 'warning' });
        } else {
            let val = { industrySpecialization: industrySpecialization, industryField: industryField, experience: industryExperience, description: industryDescription };
            setAllIndustryExperience(oldArr => [...oldArr, val]);
        }

    }

    const handleAddWorkExperiance = (event) => {
        event.stopPropagation();
        if ( !employeeType || !companyName ||  !value || !selectedYear || !selectedMonth ) {
            enqueueSnackbar("Please fill all the necessary fields", { variant: 'warning' });

        } else {
            let val = { designation: designation, employeeType: employeeType, companyName: companyName, location: location, currentlyWorking: currentlyWorking, description: value, startDate: `${selectedYear} - ${selectedMonth}`, endDate: `${selectedYear1} - ${selectedMonth1}` };
            setAllWorkExperience(oldArr => [...oldArr, val]);
        }

    }

    const handleSubmit = () => {
        let payload = {
            coachingExperience: coachingExperience,
            industryExperience: allIndustryExperience,
            workExperience: allWorkExperience,
            isProfileCompleted:true
        }
        setLoading(true)

        let user = JSON.parse(localStorage.getItem("user"));

        dispatch(createProfile(payload, user._id, user.role, (data) => {
            enqueueSnackbar(data.data.message, { variant: 'success' });
            navigate('/coach/dashboard');
        }, (err) => {
            enqueueSnackbar("Error Occured! please try again", { variant: 'error' });
        setLoading(false)
        }, localStorage.getItem("refreshToken")))
    }

    return (
        <>
            <Box py={3}>
                <Box sx={{ backgroundColor: '#F6F8F9', px: {md:5, xs:0}, py: 5, borderRadius: '20px', mx: {md:5, xs:0} }}>
                    <Paper sx={{ mx: {md:5, xs:0}, px:{md:5, xs:2}, pb: 5, borderRadius: '20px' }}>
                        <Box py={3} my={2}>
                            <Grid container>
                                <Grid item md={10}>
                                    <Typography variant="h5" sx={{ color: '#000', fontWeight: '600' }}>Coaching Experience</Typography>
                                </Grid>
                                <Grid item md={2}>
                                    <Button sx={{
                                        backgroundColor: '#2544EE',
                                        borderRadius: '5px',
                                        mx: 5,
                                        px: 5,
                                        float: 'right',
                                        '&:hover': {
                                            backgroundColor: '#FFF',
                                            color: '#2544EE',
                                        },
                                    }}
                                        onClick={handleAddCoachingExperiance}
                                        variant="contained">
                                        <AddIcon /> Add
                                    </Button>
                                </Grid>
                            </Grid>
                            <Divider sx={{ backgroundColor: '#e5e5e5', height: '1px', borderRadius: '2px', marginTop: '1rem' }} />
                        </Box>

                        <Box>


                            <FormControl sx={{ display: 'block' }}>
                                <Box >
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={6}>
                                            <Typography
                                                component="label"
                                                className="input-heading"
                                            >
                                                Coaching Field*
                                            </Typography>
                                            <Box >

                                                <input
                                                    className="profile-skills-box mb-3"
                                                    value={coachingField}
                                                    onChange={(e) => setCoachingField(e.target.value)}
                                                    placeholder="Enter your Coarse Name"
                                                    require
                                                />
                                            </Box>
                                        </Grid>

                                        <Grid item xs={12} md={6}>
                                            <Typography
                                                component="label"
                                                className="input-heading"

                                            >
                                                Experince*
                                            </Typography>
                                            <Box >

                                                <input
                                                    className="profile-skills-box mb-3"
                                                    value={experience}
                                                    onChange={(e) => setExperience(e.target.value)}
                                                    placeholder="Enter your Coarse Name"
                                                    require
                                                />
                                            </Box>
                                        </Grid>




                                        <Grid item xs={12} md={6} sx={{}}>
                                            <Typography
                                                component="label"
                                                className="input-heading"

                                            >
                                                Coaching Specification Certifications
                                            </Typography>
                                            <Box>

                                                <Button
                                                    className="profile-skills-box mb-3"
                                                    variant="outlined"
                                                    component="label"
                                                    sx={{
                                                        display: 'flex', justifyContent: 'center', alignItems: 'center', border: ' 1px solid #D2D2D2', borderRadius: '0.5rem', mr: 8, py: 4,
                                                        flexDirection: 'column'
                                                    }}
                                                >
                                                    {
                                                        coachingCertificateImage
                                                            ?
                                                            <img src={URL.createObjectURL(coachingCertificateImage)}
                                                                alt="degree"
                                                                style={{ width: "100%", height: '5.5rem', objectFit: 'contain' }}
                                                            />
                                                            :
                                                            <>
                                                                <img src={CloudUploadIcon} sx={{ mx: 5 }} />
                                                                <div className="text2Mid" style={{ color: '#000', opacity: '0.5' }}>Upload Picture</div>
                                                            </>
                                                    }
                                                    <input type="file" hidden onChange={(e) => {
                                                        if (e.target.files[0].name.includes('jpg') || e.target.files[0].name.includes('png')) {
                                                            setCoachingCertificateImage(e.target.files[0]);
                                                        } else {
                                                            enqueueSnackbar("please upload a valid image", { variant: 'warning' });
                                                        }
                                                    }} />
                                                </Button>
                                            </Box>

                                        </Grid>

                                        <Grid item xs={12} md={6} sx={{}}>
                                            <Typography
                                                component="label"
                                                className="input-heading"

                                            >
                                                Additional Certification
                                            </Typography>
                                            <Box>

                                                <Button
                                                    className="profile-skills-box mb-3"
                                                    variant="outlined"
                                                    component="label"
                                                    sx={{
                                                        display: 'flex', justifyContent: 'center', alignItems: 'center', border: ' 1px solid #D2D2D2', borderRadius: '0.5rem', mr: 8, py: 4,
                                                        flexDirection: 'column'
                                                    }}
                                                >
                                                    {
                                                        additionalCertificationImage
                                                            ?
                                                            <img src={URL.createObjectURL(additionalCertificationImage)}
                                                                alt="degree"
                                                                style={{ width: "100%", height: '5.5rem', objectFit: 'contain' }}
                                                            />
                                                            :
                                                            <>
                                                                <img src={CloudUploadIcon} sx={{ mx: 5 }} />
                                                                <div className="text2Mid" style={{ color: '#000', opacity: '0.5' }}>Upload Picture</div>
                                                            </>
                                                    }

                                                    <input type="file" hidden onChange={(e) => {
                                                        if (e.target.files[0].name.includes('jpg') || e.target.files[0].name.includes('png')) {
                                                            setAdditionalCertificationImage(e.target.files[0]);
                                                        } else {
                                                            enqueueSnackbar("please upload a valid image", { variant: 'warning' });
                                                        }
                                                    }} />
                                                </Button>
                                            </Box>

                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <Typography
                                                component="label"
                                                className="input-heading"
                                            >
                                                Description*
                                            </Typography>
                                            <JoditEditor
                                                ref={editor}
                                                onChange={(newContent) => setCoachingDescription(newContent)}
                                                value={coachingDescription}
                                            />
                                        </Grid>
                                    </Grid>
                                </Box>
                            </FormControl>
                            {
                                coachingExperience && coachingExperience.length > 0
                                    ?
                                    <Table>
                                        <TableHead>
                                            <TableCell>
                                                Coaching Field
                                            </TableCell>
                                            <TableCell>
                                                Experince
                                            </TableCell>
                                            <TableCell>
                                                Coaching Specification Certifications
                                            </TableCell>
                                            <TableCell>
                                                Additional Certification
                                            </TableCell>
                                            <TableCell>
                                                Description
                                            </TableCell>
                                        </TableHead>
                                        <TableBody>
                                            {coachingExperience.map((item, index) => (
                                                <>
                                                    {/* courseType, specialization, degreeYears, school, passingYear, percentageGrade, degreeImage */}
                                                    <TableRow key={index}>
                                                        <TableCell>
                                                            {item.coachingField}
                                                        </TableCell>
                                                        <TableCell>
                                                            {item.experience}
                                                        </TableCell>
                                                        <TableCell>
                                                            <img src={item.certificationPhotos}
                                                                alt="additional certificate"
                                                                style={{ width: '90px' }}
                                                            />
                                                        </TableCell>
                                                        <TableCell>
                                                            <img src={item.additionalCertificates}
                                                                alt="additional certificate"
                                                                style={{ width: '90px' }}
                                                            />
                                                        </TableCell>
                                                        <TableCell dangerouslySetInnerHTML={{ __html: item.description }}>

                                                        </TableCell>
                                                    </TableRow>
                                                </>
                                            ))}
                                        </TableBody>
                                    </Table>
                                    :
                                    ""
                            }
                        </Box>
                    </Paper>

                    <Paper sx={{ mx: 4, px: 5, pb: 5 }}>
                        <Box py={3} my={2}>
                            <Grid container>
                                <Grid item md={10}>
                                    <Typography sx={{ color: '#000', fontWeight: '600' }}>Industry Experience</Typography>
                                </Grid>

                                <Grid item md={2}>
                                    <Button sx={{
                                        backgroundColor: '#2544EE',
                                        borderRadius: '5px',
                                        mx: 5,
                                        px: 5,
                                        float: 'right',
                                        '&:hover': {
                                            backgroundColor: '#FFF',
                                            color: '#2544EE',
                                        },
                                    }}
                                        variant="contained"
                                        onClick={handleAddIndustryExperiance}
                                    >
                                        <AddIcon /> Add
                                    </Button>
                                </Grid>
                            </Grid>
                            <Divider sx={{ backgroundColor: '#e5e5e5', height: '1px', borderRadius: '2px', marginTop: '1rem' }} />
                        </Box>

                        <Box>
                            <FormControl sx={{ display: 'block' }}>
                                <Box >
                                    <Grid container spacing={2}>
                                        <Grid item md={12}>
                                            <Typography
                                                component="label"
                                                className="input-heading"
                                            >
                                                Industry Specialization*
                                            </Typography>
                                            <Box>
                                                <input
                                                    className="profile-skills-box mb-3"
                                                    value={industrySpecialization}
                                                    onChange={(e) => setIndustrySpecialization(e.target.value)}
                                                    placeholder="Enter your Coarse Name"
                                                    require
                                                />
                                            </Box>
                                        </Grid>

                                        <Grid item xs={12} md={6}>
                                            <Typography
                                                component="label"
                                                className="input-heading"
                                            >
                                                Industry Field*
                                            </Typography>
                                            <Box >
                                                <input
                                                    className="profile-skills-box mb-3"
                                                    value={industryField}
                                                    onChange={(e) => setIndustryField(e.target.value)}
                                                    placeholder="Enter your Coarse Name"
                                                    require
                                                />
                                            </Box>
                                        </Grid>

                                        <Grid item xs={12} md={6}>
                                            <Typography
                                                component="label"
                                                className="input-heading"
                                            >
                                                Experince*
                                            </Typography>
                                            <Box >
                                                <input
                                                    className="profile-skills-box mb-3"
                                                    value={industryExperience}
                                                    onChange={(e) => setIndustryExperience(e.target.value)}
                                                    placeholder="Enter your Coarse Name"
                                                    require
                                                />
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <Typography
                                                component="label"
                                                className="input-heading"
                                            >
                                                Description*
                                            </Typography>
                                            <JoditEditor
                                                ref={editor}
                                                onChange={(newContent) => setIndustryDescription(newContent)}
                                                value={industryDescription}
                                            />
                                        </Grid>
                                    </Grid>
                                </Box>
                            </FormControl>
                            {
                                allIndustryExperience && allIndustryExperience.length > 0
                                    ?
                                    <Table>
                                        <TableHead>
                                            <TableCell>
                                                Industry Specialization
                                            </TableCell>
                                            <TableCell>
                                                Industry Field
                                            </TableCell>
                                            <TableCell>
                                                Experince
                                            </TableCell>
                                            <TableCell>
                                                Description
                                            </TableCell>
                                        </TableHead>
                                        <TableBody>
                                            {allIndustryExperience.map((item, index) => (
                                                <>
                                                    {/* courseType, specialization, degreeYears, school, passingYear, percentageGrade, degreeImage */}
                                                    <TableRow key={index}>
                                                        <TableCell>
                                                            {item.industrySpecialization}
                                                        </TableCell>
                                                        <TableCell>
                                                            {item.industryField}
                                                        </TableCell>
                                                        <TableCell>
                                                            {item.experience}
                                                        </TableCell>
                                                        <TableCell dangerouslySetInnerHTML={{ __html: item.description }}>

                                                        </TableCell>
                                                    </TableRow>
                                                </>
                                            ))}
                                        </TableBody>
                                    </Table>
                                    :
                                    ""
                            }
                        </Box>
                    </Paper>

                    <Paper sx={{ mx: 4, px: 5, pb: 5 }}>
                        <Box py={3} my={2}>
                            <Grid container>
                                <Grid item md={10}>
                                    <Typography sx={{ color: '#000', fontWeight: '600' }}>Work Experience</Typography>

                                </Grid>
                                <Grid item md={2}>
                                    <Button sx={{
                                        backgroundColor: '#2544EE',
                                        borderRadius: '5px',
                                        mx: 5,
                                        px: 5,
                                        float: 'right',
                                        '&:hover': {
                                            backgroundColor: '#FFF',
                                            color: '#2544EE',
                                        },
                                    }}
                                        variant="contained"
                                        onClick={handleAddWorkExperiance}>
                                        <AddIcon /> Add
                                    </Button>
                                </Grid>
                            </Grid>
                            <Divider sx={{ backgroundColor: '#e5e5e5', height: '1px', borderRadius: '2px', marginTop: '1rem' }} />
                        </Box>

                        <Box>
                            <FormControl sx={{ display: 'block' }}>
                                <Box >
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={6}>
                                            <Typography
                                                component="label"
                                                className="input-heading"
                                            >
                                                Designation
                                            </Typography>
                                            <Box >
                                                <select
                                                    className="profile-skills-box mb-3"
                                                    value={designation}
                                                    onChange={(e) => setDesignation(e.target.value)}
                                                    required
                                                >
                                                    <option value="">Select </option>
                                                    <option value="Team Lead">Team Lead</option>
                                                    <option value="Software Developer">Software Developer</option>
                                                    <option value="Human Resource">Human Resource</option>
                                                </select>
                                            </Box>
                                        </Grid>

                                        <Grid item xs={12} md={6}>
                                            <Typography
                                                component="label"
                                                className="input-heading"
                                            >
                                                Employee Type*
                                            </Typography>
                                            <Box >

                                            <select
                                                    className="profile-skills-box mb-3"
                                                    value={employeeType}
                                                    onChange={(e) => setEmployeeType(e.target.value)}
                                                    required
                                                >
                                                    <option value="">Select</option>
                                                    <option value="Full-time">Full-time</option>
                                                    <option value="Part-time">Part-time</option>
                                                    <option value="Contract">Contract</option>
                                                </select>
                                            </Box>
                                        </Grid>

                                        <Grid item xs={12} md={6}>
                                            <Typography
                                                component="label"
                                                className="input-heading"
                                            >
                                                Company Name*
                                            </Typography>
                                            <Box >

                                                <input
                                                    className="profile-skills-box mb-3"
                                                    value={companyName}
                                                    onChange={(e) => setCompanyName(e.target.value)}
                                                    placeholder="Enter your Coarse Name"
                                                    require
                                                />
                                            </Box>

                                            <FormControlLabel control={<Checkbox onChange={(e) => setCurrentlyWorking(e.target.checked)} checked={currentlyWorking} />}
                                                label={
                                                    <Typography variant="h6" >I am Currently Working in This Role</Typography>
                                                } />
                                        </Grid>

                                        <Grid item xs={12} md={6}>
                                            <Typography
                                                component="label"
                                                className="input-heading"

                                            >
                                                Location
                                            </Typography>
                                            <Box >
                                                <input
                                                    className="profile-skills-box mb-3"
                                                    value={location}
                                                    onChange={(e) => setLocation(e.target.value)}
                                                    placeholder="Enter your Coarse Name"
                                                    require
                                                />
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <Typography
                                                component="label"
                                                className="input-heading"
                                            >
                                                Description*
                                            </Typography>
                                            <JoditEditor
                                                ref={editor}
                                                onChange={(newContent) => setValue(newContent)}
                                                value={value}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={6}>
                                            <Typography
                                                component="label"
                                                className="input-heading"
                                            >
                                                Start Date*
                                            </Typography>

                                            <Grid container spacing={2}>
                                                <Grid item xs={12} md={6}>
                                                    <Box >
                                                        <Select
                                                            className="input-box mb-3"
                                                            value={selectedYear}
                                                            onChange={handleYearChange}
                                                            displayEmpty
                                                        >
                                                            <MenuItem value="" disabled>
                                                                Select Year
                                                            </MenuItem>
                                                            {last30Years.map((year) => (
                                                                <MenuItem key={year} value={year}>
                                                                    {year}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </Box>
                                                </Grid>

                                                <Grid item xs={12} md={6}>
                                                    <Box >
                                                        <Select
                                                            className="input-box mb-3"
                                                            value={selectedMonth}
                                                            onChange={handleMonthChange}
                                                            displayEmpty
                                                        >
                                                            <MenuItem value="" disabled>
                                                                Select Month
                                                            </MenuItem>
                                                            {months.map((month) => (
                                                                <MenuItem key={month.value} value={month.value}>
                                                                    {month.label}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid item xs={12} md={6}>
                                            <Typography
                                                component="label"
                                                className="input-heading"
                                            >
                                                End Date*
                                            </Typography>

                                            <Grid container spacing={2}>
                                                <Grid item xs={12} md={6}>
                                                    <Box >
                                                        <Select
                                                            disabled={currentlyWorking}
                                                            className="input-box mb-3"
                                                            value={selectedYear1}
                                                            onChange={handleYearChange1}
                                                        >
                                                            <MenuItem value="" disabled>
                                                                Select Year
                                                            </MenuItem>
                                                            {last30Years.map((year) => (
                                                                <MenuItem key={year} value={year}>
                                                                    {year}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>

                                                    </Box>
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <Box >
                                                        <Select
                                                            disabled={currentlyWorking}
                                                            className="input-box mb-3"
                                                            value={selectedMonth1}
                                                            onChange={handleMonthChange1}
                                                        >
                                                            <MenuItem value="" disabled>
                                                                Select Month
                                                            </MenuItem>
                                                            {months.map((month) => (
                                                                <MenuItem key={month.value} value={month.value}>
                                                                    {month.label}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>

                                                    </Box>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </FormControl>
                            {
                                allWorkExperience && allWorkExperience.length > 0
                                    ?
                                    <Table>
                                        <TableHead>
                                            <TableCell>
                                                Designation
                                            </TableCell>
                                            <TableCell>
                                                Employee Type
                                            </TableCell>
                                            <TableCell>
                                                Company Name
                                            </TableCell>
                                            <TableCell>
                                                Location
                                            </TableCell>
                                            <TableCell>
                                                Currently Working
                                            </TableCell>
                                            <TableCell>
                                                Description
                                            </TableCell>
                                            <TableCell>
                                                Start Date
                                            </TableCell>
                                            <TableCell>
                                                End Date
                                            </TableCell>
                                        </TableHead>
                                        <TableBody>
                                            {allWorkExperience.map((item, index) => (
                                                <>
                                                    {/* courseType, specialization, degreeYears, school, passingYear, percentageGrade, degreeImage */}
                                                    <TableRow key={index}>
                                                        <TableCell>
                                                            {item.designation}
                                                        </TableCell>
                                                        <TableCell>
                                                            {item.employeeType}
                                                        </TableCell>
                                                        <TableCell>
                                                            {item.companyName}
                                                        </TableCell>
                                                        <TableCell>
                                                            {item.location}
                                                        </TableCell>
                                                        <TableCell>
                                                            {item.currentlyWorking ? 'Yes' : 'No'}
                                                        </TableCell>
                                                        <TableCell dangerouslySetInnerHTML={{ __html: item.description }}>

                                                        </TableCell>
                                                        <TableCell>
                                                            {item.startDate}
                                                        </TableCell>
                                                        <TableCell>
                                                            {item.currentlyWorking ? "Currently Working" : item.endDate}
                                                        </TableCell>
                                                    </TableRow>
                                                </>
                                            ))}
                                        </TableBody>
                                    </Table>
                                    :
                                    ""
                            }
                        </Box>

                        <Box my={3}>
                            <Button sx={{
                                backgroundColor: '#2544EE',
                                borderRadius: '2rem',
                                px: 5,
                                '&:hover': {
                                    backgroundColor: '#FFF',
                                    color: '#2544EE',
                                },
                            }}
                                disabled={loading}
                                onClick={handleSubmit}
                                variant="contained">
                                {
                                    loading
                                        ?
                                        <CircularProgress size={24} />
                                        :
                                        "Create"
                                }
                            </Button>
                        </Box>
                    </Paper>
                </Box>

            </Box >
        </>
    );
}

export default Education;
